import { createActions, createReducer } from "../../helpers/Redux";
import initialState from "../models/users";

const { actions, types } = createActions({
  addUser: ["user", "onSuccess", "onFailure"],
  updateUser: ["id", "user", "onSuccess", "onFailure"],
  setLoading: ["loading"],
  fetchUserRequest: ["page", "perPage", "onFailure"],
  exportUserRequest: ["page", "perPage", "onSuccess", "onFailure"],
  setInitialFetchIsDone: [],
  setUserTotalItems: ["totalItems"],
  setUserPerPage: ["perPage"],
  setUserPage: ["page"],
  addUsers: ["users"],
  setUserQs: ["qs"],
});

const reducer = createReducer(initialState, {
  [types.ADD_USERS]: (state, { payload }) => ({
    ...state,
    users: [...payload.users],
  }),
  [types.SET_LOADING]: (state, { payload }) => ({
    ...state,
    loading: payload.loading,
  }),
  [types.SET_INITIAL_FETCH_IS_DONE]: (state) => ({
    ...state,
    initialFetchIsDone: true,
  }),
  [types.SET_USER_TOTAL_ITEMS]: (state, { payload }) => ({
    ...state,
    totalItems: payload.totalItems,
  }),
  [types.SET_USER_PAGE]: (state, { payload }) => ({
    ...state,
    page: payload.page,
  }),
  [types.SET_USER_PER_PAGE]: (state, { payload }) => ({
    ...state,
    perPage: payload.perPage,
  }),
  [types.SET_USER_QS]: (state, { payload }) => ({
    ...state,
    qs: payload.qs,
    page: 0,
  }),
});

export { reducer as default, types, actions };
